export const PERSONAL_DATA = {
  IS_NSFW: 'isNSFW',
};

export const ACTIVITY_FEED = {
  NOTIFY: 'notify',
  NEW_BUZZ: 'newBuzz',
  NEW_COMMENTS: 'newComments',
  EDITING_BUZZES: 'editingBuzzes',
  NEW_AWARDS: 'newAwards',
  NEW_BOOST: 'newBoost',
};

export const CONTENT = {
  SAFE_BROWSING_MODE: 'safeBrowsingMode',
  OPEN_POSTS_IN_NEW_TAB: 'openPostsInNewTab',
  REDUCE_ANIMATIONS: 'reduceAnimations',
  ADULT_CONTENT: 'adultContent',
};

export const EMAIL_NOTIFICATION = {
  PLATFORM_PROMOTED: 'platformPromoted',
  USER_ACTIVITY: 'userActivity',
  BUSINESS_TIPS: 'businessTips',
  FOMO: 'fomo',
  PARTNER_UPDATES: 'partnerUpdates',
  PRODUCT_TIPS: 'productTips',
  PRODUCT_UPDATES: 'productUpdates',
  RECENT_FOLLOWERS: 'recentFollowers',
  RECOMMENDED_CHANNELS: 'recommendedChannels',
  SURVEY: 'survey',
  BUZZ: 'buzz',
  DIRECT_MESSAGE: 'directMessage',
  GENERIC_NOTIFICATION: 'genericNotification',
};

export const FILTER = {
  NOTIFICATION: 'notification',
  NO_FOLLOW: 'notFollow',
  NO_FOLLOWER: 'notFollower',
  NEW_USER: 'newUser',
  NO_PROFILE_PIC: 'noProfilePic',
  UNCONFIRMED_EMAIL: 'unconfirmedEmail',
  UNCONFIRMED_PHONE: 'unconfirmedPhone',
};

export const MESSAGE = {
  SHOW_READ_RECEIPT: 'showReadReceipt',
};

export const SECURITY = {
  PASSWORD_RESET_PROTECT: 'passwordResetProtect',
  TWO_FACTOR_AUTH: 'twoFactorAuth',
};

export const CONNECTED_ACCOUNTS = {
  IS_CONNECTED_APPLE: 'isConnectedApple',
  IS_CONNECTED_GOOGLE: 'isConnectedGoogle',
  IS_CONNECTED_TWITTER: 'isConnectedTwitter',
  IS_CONNECTED_FACEBOOK: 'isConnectedFacebook',
};

export const MESSAGES = {
  CERTAIN_USERS: 'certainUsers',
  USERS_FOLLOWING_CHANNEL: 'usersFollowChannel',
  USERS_I_FOLLOW: 'usersIFollow',
  MODERATORS: 'moderators',
  VERIFIED_USERS: 'verifiedUsers',
};
